import React, { useEffect } from "react";
import "./Menu.css";
import { CloseOutlined } from "@ant-design/icons";
import logo from "../../img/logo.png";
import { Link, useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { Drawer } from "antd";

interface MenuProps {
  open: boolean;
  setOpen: any;
}

const Menu: React.FC<MenuProps> = ({ open, setOpen }) => {
  const { t } = useTranslation()
  const location = useLocation()

  useEffect(() => {
    setOpen(false)
  }, [location.pathname])

  return (
    <Drawer
      className="menuDrawer"
      title={(
        <div className="menu-logo-container">
          <img src={logo} className="logo" alt="logo" />

          <CloseOutlined className="closeButton" onClick={() => setOpen(false)}/>
        </div>
      )}
      placement="left"
      closable={false}
      onClose={() => setOpen(!open)}
      open={open}
      key="right"
    >
        <div className="menu-left-section-inner">
          <button className="menu-button">
            <Link to="/">{t("Αρχική")}</Link>
          </button>

          <button className="menu-button">
            <Link to="/museums">{t("Μουσεία")}</Link>
          </button>

          <button className="menu-button">
            <Link to="/collection">{t("Εκθέματα")}</Link>
          </button>

          <button className="menu-button">
            <Link to="/events">{t("Εκδηλώσεις")}</Link>
          </button>

          <button className="menu-button">
            <Link to="/privacy-policy">{t("Σχετικά με το Έργο")}</Link>
          </button>
        </div>
    </Drawer>
  );
};

export default Menu;
